import React, { useState, useEffect } from 'react';
import DatePicker from 'react-datepicker';
import axios from 'axios';
import QRCode from 'qrcode.react';
import paper from '../../../src/assets/images/paper.jpg';
import 'react-datepicker/dist/react-datepicker.css';
import './Treatment.css';


function Treatment() {
    const iranProvinces = [
        { ID: 1, EnglishName: "Ardabil" },
        { ID: 2, EnglishName: "Isfahan" },
        { ID: 3, EnglishName: "Alborz" },
        { ID: 4, EnglishName: "Ilam" },
        { ID: 5, EnglishName: "East Azerbaijan" },
        { ID: 6, EnglishName: "West Azerbaijan" },
        { ID: 7, EnglishName: "Bushehr" },
        { ID: 8, EnglishName: "Tehran" },
        { ID: 9, EnglishName: "Chaharmahal and Bakhtiari" },
        { ID: 10, EnglishName: "South Khorasan" },
        { ID: 11, EnglishName: "Razavi Khorasan" },
        { ID: 12, EnglishName: "North Khorasan" },
        { ID: 13, EnglishName: "Khuzestan" },
        { ID: 14, EnglishName: "Zanjan" },
        { ID: 15, EnglishName: "Semnan" },
        { ID: 16, EnglishName: "Sistan and Baluchestan" },
        { ID: 17, EnglishName: "Fars" },
        { ID: 18, EnglishName: "Qazvin" },
        { ID: 19, EnglishName: "Qom" },
        { ID: 20, EnglishName: "Kurdistan" },
        { ID: 21, EnglishName: "Kerman" },
        { ID: 22, EnglishName: "Kermanshah" },
        { ID: 23, EnglishName: "Kohgiluyeh and Boyer-Ahmad" },
        { ID: 24, EnglishName: "Golestan" },
        { ID: 25, EnglishName: "Guilan" },
        { ID: 26, EnglishName: "Lorestan" },
        { ID: 27, EnglishName: "Mazandaran" },
        { ID: 28, EnglishName: "Markazi" },
        { ID: 29, EnglishName: "Hormozgan" },
        { ID: 30, EnglishName: "Hamadan" },
        { ID: 31, EnglishName: "Yazd" },
        { ID: 389452, EnglishName: "Mantaghe Jonob Kerman" }
    ];


    const [hasSearchParams, setHasSearchParams] = useState(false);
    const [loading, setLoading] = useState(true);
    const [provinces, setProvinces] = useState(iranProvinces);
    const [result, setResult] = useState({});
    const [attachments, setAttachments] = useState([]);
    const [resultState, setResultState] = useState('none'); // none, loading, notFound, found
    const [date, setDate] = useState(new Date());
    const [place, setPlace] = useState(null);
    const [code, setCode] = useState('');

    useEffect(() => {
        axios
            .post('Place/List', { Type: 2 })
            .then((result) => {
                if (result.data.Success && result.data.Data && result.data.Data.length) {
                    //setProvinces(result.data.Data);
                }

                if (window.location.search) {
                    const params = new URLSearchParams(window.location.search);
                    setCode(params.get('sn'));
                    setPlace(params.get('poi'));
                    setDate(new Date(parseInt(params.get('d'))));
                    setHasSearchParams(true);
                }
            })
            .finally(() => {
                setLoading(false);
            });
    }, []);
    useEffect(() => {
        if (hasSearchParams)
            search();
    }, [hasSearchParams]);

    return (
        <div style={{ direction: 'rtl' }}>
            <h2>Treatment Certificate Search</h2>

            <fieldset disabled={loading} style={{ all: 'unset', display: 'block' }}>
                <div className="row">
                    <div className="form-group">
                        <label>Serial No</label>
                        <input type="text" className="form-control" value={code} onChange={e => setCode(e.target.value)} />
                    </div>
                    <div className="form-group">
                        <label>Place of Issue</label>
                        <select className="form-control" value={place} onChange={e => setPlace(e.target.value)}>
                            {provinces.map(function (p, i) {
                                return (<option key={i} value={p.ID}>{p.EnglishName}</option>);
                            })}
                        </select>
                    </div>
                    <div className="form-group">
                        <label>Date</label>
                        <DatePicker
                            selected={date}
                            onChange={value => setDate(value)}
                            className="form-control"
                        />
                    </div>
                </div>
                <div className="row button-container">
                    <button type="button" onClick={search}>Search</button>
                </div>
            </fieldset>
            <QRCode
                id="qrcode-canvas"
                style={{ display: 'none' }}
                value={`http://ephyto.pms.ppo.ir/treatment?sn=${code}&poi=${place}&d=${date.getTime()}`}
            />
            {resultState !== 'none' && (
                <div className="row result-container">
                    {resultState === 'loading' && <code>Loading .....</code>}
                    {resultState === 'notFound' && <code>No Treatment certificate was found with these information.</code>}
                    {resultState === 'found' && (
                        <code>
                            Certificate exists. <span className="link" onClick={print}>(view document)</span>
                            {attachments.map((attachment, index) => {
                                return (
                                    <p key={index}>
                                        <a href={attachment.filePath} target="_blank">attachment #{index + 1}</a>
                                    </p>
                                );
                            })}
                        </code>
                    )}
                </div>
            )}
            {resultState === 'found' && (
                <div id="print" style={{ display: 'none' }}>
                    <div id="print-container" style={{ padding: '10px' }}>
                        <div className="headCenter"><h4>TREATMENT CERTIFICATE</h4></div>
                        <header className="printHeader">
                            <div className="headAside" style={{ float: 'left', width: 20 + '%', border: 1 + 'px solid' }}>
                                <table className="tableBorderNone ptable" style={{fontSize: '10px',fontWeight:600}}>
                                    <tr>
                                        <td>Number:</td>
                                        <td>{result.Number}</td>
                                    </tr>
                                    <tr>
                                        <td>Date:</td>
                                        <td>{result.IssuanceDateString.substring(5, 7) + '/' + result.IssuanceDateString.substring(8, 10) + '/' + result.IssuanceDateString.substring(0,4)}</td>
                                    </tr>
                                </table>
                            </div>
                            <div id="qrcode-canvas"  className="qrContainer">
                                <img id="qrcode-image"  />
                            </div>
                            <div className="headAside" style={{ float: 'right', width: '15%', border: '1px solid' }}>
                                <table className="tableBorderNone ptable" style={{ fontSize: '10px', fontWeight: 600 }}>
                                    <tr>
                                        <td className="tac" style={{ textAlign: 'center !important' }}>company code:</td>
                                    </tr>
                                    <tr>
                                        <td className="tac"  style={{ textAlign: 'center  !important' }}>{result.DisinfectionCompanyCode}</td>
                                    </tr>
                                </table>
                            </div>
                        </header>
                        <section className="printContent">
                            <p class="SingleP" style={{ fontSize: '13px', display: 'block', textAlign: 'left', margin: '0 auto 5px auto', width : '93%' }}>Description of Consignment</p>

                            <table className="ptable ">
                                <tr className="dtr">
                                    <td colspan="2">
                                        <p>1.Target of Treatment </p>
                                        <div className="Options" style={{ display: 'inline-block', float: 'right' }}>
                                            <p className="PAnswer ib" style={{ display: 'inline-block' }}>a.Commodity
                                                <div class="checkbox-Container">
                                                    {result.Commodity && <div class="if-checked"></div>}
                                                    {!result.Commodity && <div class="if-Notchecked"></div>}
                                                </div>
                                            </p>
                                            <p className="PAnswer ib" style={{ display: 'inline-block' }}> b.Wood Packaging Materials in accordance with ISPM15 IPPC
                                                <div class="checkbox-Container">
                                                    {result.WoodPackaging && <div class="if-checked"></div>}
                                                    {!result.WoodPackaging && <div class="if-Notchecked"></div>}
                                                </div>
                                            </p>
                                        </div>
                                        <br />
                                        <p>&nbsp;</p>
                                    </td>
                                </tr>
                                <tr className="dtr">
                                    <td style={{ width : '50%' }}>
                                        <p className="PWithMargin">2. Name of Plant and Plant Products:</p>
                                        <p className="PAnswer">{(result.ProductPrefix ? result.ProductPrefix : '') + ' ' + result.ProductEnglishName + ' ' + (result.ProductPostfix ? result.ProductPostfix : '')}</p>
                                    </td>
                                    <td>
                                        <p className="PWithMargin">3. Quantity(ton/m3):</p>
                                        <p className="PAnswer">{result.Quantity}</p>
                                    </td>
                                </tr>
                                <tr className="dtr">
                                    <td>
                                        <p className="PWithMargin">4. Country of Origin:</p>
                                        <p className="PAnswer">{result.OriginCountryEnglishName}</p>
                                    </td>
                                    <td>
                                        <p className="PWithMargin">5. Country of Destination:</p>
                                        <p className="PAnswer">{result.DestinationCountryEnglishName}</p>
                                    </td>
                                </tr>
                                <tr className="dtr">
                                    <td>
                                        <p className="PWithMargin">6. Name And Address of Exporter: </p>
                                        <p className="PAnswer">{result.ExporterName}</p>
                                        <p className="PAnswer">{result.ExporterAddress}</p>
                                    </td>
                                    <td>
                                        <p className="PWithMargin">7. Name And Address of Importer:</p>
                                        <p className="PAnswer">{result.ImporterName}</p>
                                        <p className="PAnswer">{result.ImporterAddress}</p>
                                    </td>
                                </tr>
                                <tr className="dtr">
                                    <td>
                                        <p className="PWithMargin">8. Place of Treatment</p>
                                        <p className="PAnswer">{result.TreatmentPlace}</p>
                                    </td>
                                    <td>
                                        <p className="PWithMargin">9. Disinfection Date</p>
                                        <p className="PAnswer">{result.DisinfectionDateString.slice(0, 10).toString()}</p>
                                    </td>
                                </tr>
                            </table>

                            <h4 style={{ fontWeight: 'bold', margin: '5px auto',fontSize : '13px' }}>TREATMENT DETAILS</h4>

                            <table className="ptable ">
                                <tr className="dtr">
                                    <td colspan="5" style={{ textAlign: 'center' }}>
                                        <p style={{ display: 'block', textAlign: 'center', fontSize: '13px', paddingBottom : '11px' }}>10. Treatment Method:</p>
                                    </td>
                                </tr>
                                <tr className="dtr">
                                    <td colspan="5" style={{ paddingBottom : '12px' }}>
                                        <div className="Options" style={{ textAlign: 'center' }}>
                                            <p className="PAnswer ib" style={{ display: 'inline-block ', fontSize: '12px', fontWeight : 400 }}>a.Under Tents orPlastic
                                                <div class="checkbox-Container">
                                                    {!result.IsThermalDisinfection && result.UnderTents && <div class="if-checked"></div>}
                                                    {result.IsThermalDisinfection || !result.UnderTents && <div class="if-Notchecked"></div>}
                                                </div>
                                            </p>

                                            <p className="PAnswer ib" style={{ display: 'inline-block ', fontSize: '12px', fontWeight: 400 }}>b. Container/s
                                                <div class="checkbox-Container">
                                                    {!result.IsThermalDisinfection && result.Container && <div class="if-checked"></div>}
                                                    {result.IsThermalDisinfection || !result.Container && <div class="if-Notchecked"></div>}
                                                </div>
                                            </p>

                                            <p className="PAnswer ib" style={{ display: 'inline-block', fontSize: '12px', fontWeight: 400 }}>c.Permanent Chamber
                                                <div class="checkbox-Container">
                                                    {!result.IsThermalDisinfection && result.PermanentChamber && <div class="if-checked"></div>}
                                                    {result.IsThermalDisinfection || !result.PermanentChamber && <div class="if-Notchecked"></div>}
                                                </div>
                                            </p>

                                            <p className="PAnswer ib" style={{ display: 'inline-block', fontSize: '12px', fontWeight: 400 }}>d.Reduced Atmosphere
                                                <div class="checkbox-Container">
                                                    {!result.IsThermalDisinfection && result.ReducedAtmosphere && <div class="if-checked"></div>}
                                                    {result.IsThermalDisinfection || !result.ReducedAtmosphere && <div class="if-Notchecked"></div>}
                                                </div>
                                            </p>

                                            <p className="PAnswer ib" style={{ display: 'inline-block ', fontSize: '12px', fontWeight: 400 }}>e.Other Methods
                                                <div class="checkbox-Container">
                                                    {!result.IsThermalDisinfection && result.OtherMethods && <div class="if-checked"></div>}
                                                    {result.IsThermalDisinfection || !result.OtherMethods && <div class="if-Notchecked"></div>}
                                                </div>
                                            </p>
                                        </div>
                                    </td>
                                </tr>
                                <tr className="dtr">
                                    <td>
                                        <p className="PWithMargin" style={{ fontSize:'10px' }}>11. Chemical(Active<br /> ingredients)</p>
                                        <p className="PAnswer">{result.ChemicalTypeEngishName}</p>
                                    </td>
                                    <td>
                                        <p className="PWithMargin" style={{ fontSize: '10px' }}>12. Dosage(g/m3)</p>
                                        <br/>
                                        <p className="PAnswer">{!result.IsThermalDisinfection ? result.Dosage : ''}</p>
                                    </td>
                                    <td>
                                        <p className="PWithMargin" style={{ fontSize: '10px' }}>13.Duration of<br /> Treatment(hours)</p>
                                        <p className="PAnswer">{!result.IsThermalDisinfection ? result.TreatmentDuration :''}</p>
                                    </td>
                                    <td>
                                        <div className="Options">
                                            <div style={{ display: 'block'}}>
                                                <p className="PAnswer" style={{ display: 'inline-block ', fontSize : '10px' }}>14. a.Normal Atmospheric Pressure
                                                    <div class="checkbox-Container">
                                                            {!result.IsThermalDisinfection && result.NormalAtmosphericPressure && <div class="if-checked"></div>}
                                                            {result.IsThermalDisinfection || !result.NormalAtmosphericPressure && <div class="if-Notchecked"></div>}
                                                    </div>
                                                </p>
                                            </div>
                                            <div style={{ display: 'block', textAlign: 'center' }}>
                                                <p className="PWithMargin" style={{ display: 'inline-block', fontSize : '10px' }}>b.Reduced Atmosphere (with the Pressure)</p>
                                                <p className="PAnswer">{!result.IsThermalDisinfection ? result.PressureAmount : ''}</p>
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <p className="PWithMargin" style={{ fontSize: '10px' }}>15. Minimum<br /> Temperature</p>
                                        <p className="PAnswer">{!result.IsThermalDisinfection ? result.MinimumTemperature : ''}</p>
                                    </td>
                                </tr>
                            </table>

                            <table className="ptable" style={{ marginTop: '5px' }}>
                                <tr className="dtr">
                                    <td colspan="3" style={{ textAlign: 'center' }}>
                                        <p style={{ display: 'block', textAlign: 'center', fontSize : '13px' }}>16. Heat Treatment Method</p>
                                    </td>
                                </tr>
                                <tr className="dtr">
                                    <td>
                                        <div style={{ display: 'block', textAlign: 'center' }}>
                                            <p className="PAnswer" style={{ display: 'inline-block', fontSize : '11px' }}>a. Heat Treatment
                                                <div class="checkbox-Container">
                                                    {result.IsThermalDisinfection && result.HeatTreatment && <div class="if-checked"></div>}
                                                    {!result.IsThermalDisinfection || !result.HeatTreatment && <div class="if-Notchecked"></div>}
                                                </div>
                                            </p>
                                        </div>
                                    </td>
                                    <td>
                                        <div style={{ display: 'block', textAlign: 'center' }}>
                                            <p className="PAnswer ib" style={{ display: 'inline-block', fontSize: '11px'}}>b.Kiln Dry
                                                <div class="checkbox-Container">
                                                    {result.IsThermalDisinfection && result.KilnDry && <div class="if-checked"></div>}
                                                    {!result.IsThermalDisinfection || !result.KilnDry && <div class="if-Notchecked"></div>}
                                                </div>
                                            </p>
                                        </div>
                                    </td>
                                    <td>
                                        <div style={{ display: 'block', textAlign: 'center' }}>
                                            <p className="PAnswer ib" style={{ display: 'inline-block', fontSize: '11px'}}>c.Other Methods
                                                <div class="checkbox-Container">
                                                    {result.IsThermalDisinfection && result.HeatTreatmentOtherMethods && <div class="if-checked"></div>}
                                                    {!result.IsThermalDisinfection || !result.HeatTreatmentOtherMethods && <div class="if-Notchecked"></div>}
                                                </div>
                                            </p>
                                        </div>
                                    </td>
                                </tr>
                                <tr className="dtr">
                                    <td>
                                        <p className="PWithMargin">17. Temperature</p>
                                        <p className="PAnswer">{(result.IsThermalDisinfection ? result.Temperature : '')}</p>
                                    </td>
                                    <td>
                                        <p className="PWithMargin">18. Relative Humidity</p>
                                        <p className="PAnswer">{(result.IsThermalDisinfection ? result.RelativeHumidity : '')}</p>
                                    </td>
                                    <td>
                                        <p className="PWithMargin">19. Duration of Treatment(hours)</p>
                                        <p className="PAnswer">{(result.IsThermalDisinfection ? result.HeatTreatmentDuration : '')}</p>
                                    </td>
                                </tr>
                            </table>

                            <table className="ptable" style={{ marginTop: '5px' }}>
                                <tr className="dtr">
                                    <td colspan="3" style={{ textAlign: 'center' }}>
                                        <p style={{ display: 'block', textAlign: 'center', fontSize: '13px' }}>20. Cold Treatment Method</p>
                                    </td>
                                </tr>
                                <tr className="dtr">
                                    <td>
                                        <div style={{ display: 'block', textAlign: 'center' }}>
                                            <p className="PAnswer" style={{ display: 'inline-block', fontSize: '11px' }}>a. Cold Store
                                                <div class="checkbox-Container">
                                                    {result.IsCoolingDisinfection && result.Morgue && <div class="if-checked"></div>}
                                                    {!result.IsCoolingDisinfection || !result.Morgue && <div class="if-Notchecked"></div>}
                                                </div>
                                            </p>
                                        </div>
                                    </td>
                                    <td>
                                        <div style={{ display: 'block', textAlign: 'center' }}>
                                            <p className="PAnswer ib" style={{ display: 'inline-block', fontSize: '11px' }}>b. Refrigerated Containers
                                                <div class="checkbox-Container">
                                                    {result.IsCoolingDisinfection && result.PortableContainer && <div class="if-checked"></div>}
                                                    {!result.IsCoolingDisinfection || !result.PortableContainer && <div class="if-Notchecked"></div>}
                                                </div>
                                            </p>
                                        </div>
                                    </td>
                                </tr>
                            </table>

                            <p className="SingleP" style={{ marginBottom: 0, fontSize: '10px', marginTop : '2px' }}>
                                21.It is hereby certified that plants and plant products described above are treated, in accordance with the instructions and guidelines of the Plant
                                Protection Organization and accuracy of this certificate is approved by the company.
                            </p>

                            <p className="SingleP" style={{ marginBottom: 0, fontSize: '10px' }}>
                                <span>Note : </span>
                                According to the Montreal Protocol, Quarantine application, with respect to methyl bromide is allowed and Pre-shipment application of
                                methyl bromide is permitted in case it has been applied no later than 21 days before export.
                            </p>

                            <p className="SingleP" style={{ fontSize: '12px' }}>22. ADDITIONAL DECLARATIONS</p>
                            <p className="SingleP" style={{ fontWeight: 400, fontSize: 12 + 'px', marginTop : 0 }}>{result.AdditionalDeclarations}</p>
                            <br/>
                            <div class="printHeader" style={{ width: '96%' }}>
                                <div class="headAside" style={{ float: 'left', width: '55%' }}>
                                    <table class="ptable tableBorderNone" style={{ fontSize : '13px' }}>
                                        <tr className="dtr">
                                            <td><b>23.First Name and Last</b></td>
                                            <td>{result.CreatorPersonEnglishName}</td>
                                        </tr>
                                    </table>
                                </div>
                                <div class="headAside" style={{ float: 'right', width: '45%' }}>
                                    <table class="ptable tableBorderNone" style={{ fontSize: '13px' }}>
                                        <tr>
                                            <td className=" tar"><b>24. Signature and Company Stamp</b></td>
                                        </tr>
                                    </table>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            )}
        </div>
    );


    function search() {
        setResultState('loading');
        let exists = false;
        axios.post('ETreatment/Get', {
            Number: code,
            ProvinceID: parseInt(place),
            IssueDate: date
        }).then((response) => {
            if (response && response.data && response.data.Data) {
                exists = true;
                setResult(response.data.Data);
                return axios.post('Document/GetAttachments', { ObjectID: response.data.Data.ID });
            }
        }).then((response) => {
            if (response && response.data && response.data.Data && response.data.Data.length) {
                response.data.Data.map((item) => {
                    let filePath = window.location.origin;
                    if (filePath === undefined) {
                        filePath = window.location.protocol + '//'
                            + window.location.hostname
                            + (window.location.port ? ':' + window.location.port : '');
                    }
                    filePath += `/Uploads/${item.FileNameWithExtension}`;
                    item.filePath = filePath;
                });

                setAttachments(response.data.Data.filter((attachment) => {
                    return [4, 5].indexOf(attachment.Type) !== -1;
                }));
            }

            if (exists)
                setResultState('found');
            else
                setResultState('notFound');
        });
    }
    function print() {
        var canvas = document.getElementById("qrcode-canvas");
        var img = canvas.toDataURL("image/png");
        document.getElementById('qrcode-image').src = img;

        const toPrint = document.getElementById('print');
        const popupWin = window.open(
            "",
            "_blank",
            "width=800,height=600,location=no,left=100px"
        );
        popupWin.document.open();
        popupWin.document.write(
            //z"<html><title></title><style>.tar{text-align : right !important}.ctr td{text-align : center !important;}.qrContainer{width:15%;text-align: center;}.ac{text-align : center !important;}.ib{display : inline-block !important}table{display:table;width:95%}td{padding:2px;vertical-align:text-top}table,td,tr{border:1px solid #000;border-collapse:collapse}.dtr td{text-align:left}.printHeader{display:flex;align-items:center;justify-content:space-between;width:90%;margin:0 auto}.headAside{width:13%;box-sizing:border-box;text-align:center}.headCenter{width:100%;text-align:center;margin:100px auto 5px auto!important;font-size:25px}.printContent{padding:5px;margin:5px auto!important;text-align:center;width:95%;display:flex;flex-wrap:wrap;align-content:center;justify-content:center}td p{display:inline-block;font-size:15px;font-weight:600;margin-top:0!important;text-align:left;vertical-align:text-top;margin-bottom:0!important}.PWithMargin{margin-bottom:5px;display:block!important;font-size:13px}.SingleP{width:95%;font-weight:600;font-size:10px;text-align:left;justify-content:left;margin-bottom:5px}.tableBorderNone{border:0!important;border-collapse:separate}.tableBorderNone .dtr td{border:0!important;text-align:left!important}.tableBorderNone td{border:0!important;}.PAnswer{font-size:12px;font-weight:400;text-align:center;margin:0 .5vw!important;display:block}.checkbox{margin:0 0!important}.checkbox-Container{display:inline-block;overflow:hidden;padding:1px}.if-Notchecked,.if-checked{border:1px solid #bbb;border-radius:3px;width:11px;height:11px;display:block}.if-checked{background-color:#000}</style></head><body>"
            "<html><title></title><style>.tar{text-align : right !important}.tac{text-align: center !important}.ib{display:inline-block !important}.ptable{display:table;width:95%}.ptable tr td{padding:2px;vertical-align:text-top;text-align:left}.ptable,.ptable td,.ptable tr{border:1px solid #000;border-collapse:collapse}.printHeader{display:flex;align-items:flex-end;justify-content:space-between;width:87%;margin:0 auto}.headAside{width:13%;box-sizing:border-box;text-align:center}.headCenter{width:100%;text-align:center;margin:110px auto 5px auto!important;font-size:25px}.headCenter>h4{margin:0!important}.printContent{padding:5px;margin:0 auto!important;padding-bottom:10px!important;text-align:center;width:95%;display:flex;flex-wrap:wrap;align-content:center;justify-content:center}td p{display:inline-block;font-size:15px;font-weight:600;margin-top:0!important;text-align:left;vertical-align:text-top;margin-bottom:0!important}.PWithMargin{margin-bottom:2px!important;display:block!important;font-size:13px}.SingleP{width:95%;font-weight:600;font-size:10px;text-align:left;justify-content:left;margin-bottom:5px}.tableBorderNone{border:0!important;border-collapse:separate}.tableBorderNone td{border:0!important;text-align:left}.PAnswer{font-size:13px;font-weight:600;text-align:center;margin:0 .5vw!important;display:block;margin-bottom:1px!important}.checkbox{margin:0 0!important}.checkbox-Container{display:inline-block;overflow:hidden;padding:1px}.if-Notchecked,.if-checked{border:5px solid #fff;border-radius:2px;width:0;height:0;display:block;outline:1px solid}.if-checked{border-color:#4a4a4a!important}#qrcode-canvas>img{width:60px!important;height:60px!important;text-align:center}</style></head><body>"
        );
        popupWin.document.write(toPrint.innerHTML);
        popupWin.document.write("</html>");
        popupWin.document.close();
    }

}

export default Treatment;